import { useEffect, useRef } from "react";
import { useCall } from "./CallContext";
import { PhoneIcon, VideoIcon, EndCallIcon } from "../../svg/chat";
import "./IncomingCall.css";

export default function IncomingCall() {
  const { callState, answerCall, rejectCall } = useCall();
  const audioRef = useRef(null);

  // Play ringtone
  useEffect(() => {
    if (callState.isIncoming && callState.isRinging) {
      // Create audio element for ringtone
      audioRef.current = new Audio("/sounds/ringtone.mp3");
      audioRef.current.loop = true;
      audioRef.current.play().catch(console.error);
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, [callState.isIncoming, callState.isRinging]);

  if (!callState.isIncoming || !callState.isRinging) {
    return null;
  }

  const callerName = callState.caller?.name ||
    `${callState.caller?.first_name || ""} ${callState.caller?.last_name || ""}`.trim() ||
    "Usuario";

  const callerPicture = callState.caller?.picture || "/images/default_user.png";

  return (
    <div className="incoming_call_overlay">
      <div className="incoming_call_modal">
        <div className="call_type_badge">
          {callState.callType === "video" ? (
            <>
              <VideoIcon color="#fff" />
              <span>Chamada de video</span>
            </>
          ) : (
            <>
              <PhoneIcon color="#fff" />
              <span>Chamada de voz</span>
            </>
          )}
        </div>

        <div className="caller_info">
          <div className="caller_avatar">
            <img src={callerPicture} alt={callerName} />
            <div className="pulse_ring"></div>
            <div className="pulse_ring delay"></div>
          </div>
          <h2 className="caller_name">{callerName}</h2>
          <p className="call_status_text">Esta ligando...</p>
        </div>

        <div className="call_actions">
          <button
            className="call_action_btn reject"
            onClick={rejectCall}
            title="Recusar"
          >
            <EndCallIcon color="#fff" />
            <span>Recusar</span>
          </button>

          <button
            className="call_action_btn answer"
            onClick={answerCall}
            title="Atender"
          >
            {callState.callType === "video" ? (
              <VideoIcon color="#fff" />
            ) : (
              <PhoneIcon color="#fff" />
            )}
            <span>Atender</span>
          </button>
        </div>
      </div>
    </div>
  );
}
